class RadioPharmacyMedicine {
    checkStatus(response) {
        switch (response.status) {
            case 200:
            case 204:
            case 210:
                //console.log('Conexión corecta', response.status);
                break;
            default:
                throw new Error(`${response.status} - ${response.statusText}!`);

        }
    }

    //Lista los Farmacos de la Radiofarmacia
    async listMedicine() {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}radiofarmacia-farmacos/listar`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                this.checkStatus(response);
                return response.json();
            })
            .then(data => {
                datos = data;
            })
            .catch((error) => {
                datos = { "existe": false, "contenido": error.toString() };
            });
        return datos;
    }
}

export default new RadioPharmacyMedicine();